import { getSelectedPerson } from 'store/selectedBubble/reducer';
import PERSONS from 'story/PERSONS.json';
import { useDispatch, useSelector } from 'react-redux';
import { Sprite } from '@inlet/react-pixi';
import { getGlobal } from 'store';
import * as PIXI from 'pixi.js';
import gsap from 'gsap';
import { useEffect, useRef, useState } from 'react';
import { CachedSprites, fetchImage } from 'lib/utils';
import { setPersonsLoaded } from 'store/resources';

const SIZE_ASPECT = 0.9;

export const PersonComponent = () => {
  const currentPersonID = useSelector(getSelectedPerson);
  const { height, width } = useSelector(getGlobal);
  const dispatch = useDispatch();

  const personRef = useRef<PIXI.Sprite>(null);

  const [persons, setPersons] = useState<CachedSprites>([]);
  const currentPerson = persons[currentPersonID] || { height, width };

  useEffect(() => {
    Promise.allSettled(PERSONS.map((p) => fetchImage(p.id, p.img))).then((pers) => {
      // @ts-ignore
      setPersons(pers.reduce((a, b) => ({ ...a, ...(b.value || {}) }), {}));
      dispatch(setPersonsLoaded(true));
    });
  }, []);

  // SIZE PARAMS
  const imageAspect = currentPerson.height / currentPerson.width;
  const spriteHeight = height * SIZE_ASPECT;
  const spriteWidth = spriteHeight / imageAspect;
  const spriteScale: [number, number] =
    PERSONS[currentPersonID]?.position === 'left' ? [0, 0] : [-1, 0];

  // POS PARAMS
  const isLeft = PERSONS[currentPersonID]?.position === 'left';
  const startSpriteX = isLeft ? -width : width + spriteWidth;
  const spriteX = isLeft ? 0 : width / 2 + spriteWidth;
  const spriteY = height * (1 - SIZE_ASPECT);

  useEffect(() => {
    if (currentPerson.texture) {
      gsap.to(personRef.current, {
        x: startSpriteX,
        duration: 0,
      });
      const anim = gsap.to(personRef.current, {
        x: spriteX,
        duration: 0.5,
      });

      return () => {
        anim.pause();
      };
    }
  }, [currentPerson.texture]);

  return !currentPerson.texture ? null : (
    <Sprite
      key={currentPerson.texture.textureCacheIds[0]}
      texture={currentPerson.texture}
      scale={spriteScale}
      x={spriteX}
      y={spriteY}
      height={spriteHeight}
      width={spriteWidth}
      ref={personRef}
    />
  );
};
